<template>
  <div
    class="preloaderBg"
    :style="`backgroundColor: ${getDarkMode ? '#1A1C27' : '#FDFDFD'}` "
    id="preloader"
    :onload="preloader"
  >
    <div class="preloader" :style="`filter: ${getDarkMode ? 'brightness(2)' : ''}`"></div>
    <div class="preloader2"></div>
  </div>
</template>

<style lang="scss" scoped>
@import "./Preloader.scss";
</style>

<script>
import { mapGetters } from "vuex";

export default {
  name: "preloader",
  methods: {
    preloader() {
      setTimeout(this.showPage, 5000);
    },
    showPage() {
      document.getElementById("preloader").style.display = "none";
    },
  },
  computed: {
    ...mapGetters(["getDarkMode"]),
    preloaderBackgroundStyle() {
      return {
        backgroundColor: this.getDarkMode,
      };
    },
  },
};
</script>


